export default function enumToOptions<T extends Record<string, string | number>>(e: T) {
  return Object.keys(e)
    .filter((k) => Number.isNaN(Number(k)))
    .map((name) => ({
      id: e[name] as number,
      name,
    }));
}